import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StructuredData from '../components/StructuredData';
import '../styles/MessagePage.scss';

const DirectorMessage = () => {
  const { t } = useTranslation();

  return (
    <div className="message-page">
      <StructuredData type="organization" />
      <Helmet>
        <title>{`${t('director_message_title')} - ${t('school_name')}`}</title>
        <meta
          name="description"
          content={`Read the inspiring message from our Director, ${t('director_name')}, highlighting 30 years of educational excellence and holistic student development at Prabhat Tara Vidya Niketan.`}
        />
        <link rel="canonical" href="https://prabhattaravidyaniketan.in/director-message" />
      </Helmet>

      <div className="container">
        <h2 className="message-title">{t('director_message_title')}</h2>
        <div className="profile-section">
          <img
            src="/images/director.png"
            alt={`Director ${t('director_name')}`}
            className="profile-image"
            loading="lazy"
          />
          <h3>{t('director_name')}</h3>
          <p className="designation">{t('director_designation')}</p>
        </div>
        <p className="message-text">
          {t('director_message')}
        </p>
      </div>
    </div>
  );
};

export default DirectorMessage;
